'use es6';

import { HISTORY_METHOD_CALLED } from 'DesignData/actions/ActionTypes';
export const routerMiddleware = history => () => next => action => {
  if (action.type === HISTORY_METHOD_CALLED) {
    const {
      payload: {
        method,
        args
      }
    } = action;

    switch (method) {
      case 'push':
        if (typeof args[0] === 'string') {
          history.push({
            pathname: args[0],
            search: history.location.search
          });
        } else if (typeof args[0] === 'object') {
          history.push(args[0]);
        }

        break;

      case 'replace':
        history.replace(args[0]);
        break;

      default:
        break;
    }
  }

  return next(action);
};